import React from "react";
import styled from "styled-components";
import { Link } from "react-router-dom";

export default function FullButton({ title, action, border, to }) {
  if (to) {
    return (
      <LinkWrapper to={to}>
        <Wrapper className="animate pointer radius8" border={border}>
          {title}
        </Wrapper>
      </LinkWrapper>
    );
  }

  return (
    <Wrapper
      className="animate pointer radius8"
      onClick={action ? () => action() : null}
      border={border}
    >
      {title}
    </Wrapper>
  );
}

const LinkWrapper = styled(Link)`
  text-decoration: none;
  width: 100%;
  display: block;
`;

const Wrapper = styled.button`
  border: 1px solid ${(props) => (props.border ? "#4b2e83" : "transparent")};
  background: ${(props) => (props.border ? "transparent" : "#f8f8ff")};
  backdrop-filter: blur(10px);
  width: 100%;
  padding: 16px 24px;
  min-height: 50px;
  outline: none;
  color: #4b2e83;
  cursor: pointer;
  font-weight: 600;
  font-size: clamp(0.875rem, 2vw, 1rem);
  transition: all 0.3s ease;
  box-shadow: 0 8px 25px rgba(75, 46, 131, 0.2);
  border-radius: 8px;
  display: flex;
  align-items: center;
  justify-content: center;
  
  @media (max-width: 480px) {
    padding: 14px 20px;
    min-height: 48px;
  }

  :hover {
    transform: translateY(-3px);
    background: ${(props) => (props.border ? "rgba(75, 46, 131, 0.1)" : "#f0f0f0")};
    border: 1px solid #4b2e83;
    box-shadow: 0 15px 40px rgba(75, 46, 131, 0.3);
  }

  :active {
    transform: translateY(-1px);
    box-shadow: 0 8px 25px rgba(75, 46, 131, 0.2);
  }
`;

